export const useIOS = () => {
  return /iphone|ipod|ipad/i.test(navigator.userAgent)
}
